// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
import { CountryInfoFragmentDoc, ProfileFragmentDoc, UserFragmentDoc } from '../../queries/__generated__/UserQuery';
export type UserSettingName =
  | 'allowNonFriendPrivMsg'
  | 'blockAllFriendReq'
  | 'blockFriendReqNotifs'
  | 'blockGettingRain'
  | 'blockPrivMsgNotifs'
  | 'gameNamesInEnglish'
  | 'hasVisitedBCIO'
  | 'hideAllStats'
  | 'hideBets'
  | 'hideRaceStats'
  | 'inGameCurrencyOnboardingClosed'
  | 'loyaltyLandingDisabled'
  | 'loyaltyLevelNotfDisabled'
  | 'preferredInGameCurrency'
  | 'rtpLiveOnboardingClosed'
  | 'siteTheme'
  | 'verifyEmailClosed'
  | 'wallets';

export type UpdateUserSettingsMutationVariables = Exact<{
  value: string;
  name: Types.UserSettingName;
  site?: string | null | undefined;
}>;


export type UpdateUserSettingsMutation = { userManagementUpdateUserSettings: { userManagement: { id: string, user: { __typename: 'UserManagementUser', id: string, email: string | undefined, username: string | undefined, signupTime: number | undefined, authMethods: Array<string | undefined> | undefined } | undefined, profile: { __typename: 'UserManagementProfile', _id: string | undefined, id: string, firstName: string | undefined, lastName: string | undefined, maidenName: string | undefined, email: string | undefined, country: string | undefined, phone: string | undefined, affiliateID: string | undefined, city: string | undefined, zip: string | undefined, house: string | undefined, address: string | undefined, state: string | undefined, dateOfBirth: number | undefined, language: string | undefined, hasOtp: boolean | undefined, hasSMS2FA: boolean | undefined, emailVerified: boolean | undefined, passwordChangeDate: number | undefined, contactsRequestedTime: number | undefined, lineId: string | undefined, conversionCurrency: string | undefined, telegramId: string | undefined, settings: { siteTheme: string | undefined, wallets: string | undefined, loyaltyLandingDisabled: string | undefined, loyaltyLevelNotfDisabled: string | undefined, verifyEmailClosed: string | undefined, rtpLiveOnboardingClosed: string | undefined, preferredInGameCurrency: string | undefined, inGameCurrencyOnboardingClosed: string | undefined, hasVisitedBCIO: string | undefined } | undefined } | undefined, countryInfo: { __typename: 'UserManagementCountryInfo', id: string, countryCode: string | undefined, blocked: boolean | undefined } | undefined } | undefined, errors: Array<{ message: string | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };

export type ErrorsFragment = { message: string | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined };

export type UserManagementFragment = { id: string, user: { __typename: 'UserManagementUser', id: string, email: string | undefined, username: string | undefined, signupTime: number | undefined, authMethods: Array<string | undefined> | undefined } | undefined, profile: { __typename: 'UserManagementProfile', _id: string | undefined, id: string, firstName: string | undefined, lastName: string | undefined, maidenName: string | undefined, email: string | undefined, country: string | undefined, phone: string | undefined, affiliateID: string | undefined, city: string | undefined, zip: string | undefined, house: string | undefined, address: string | undefined, state: string | undefined, dateOfBirth: number | undefined, language: string | undefined, hasOtp: boolean | undefined, hasSMS2FA: boolean | undefined, emailVerified: boolean | undefined, passwordChangeDate: number | undefined, contactsRequestedTime: number | undefined, lineId: string | undefined, conversionCurrency: string | undefined, telegramId: string | undefined, settings: { siteTheme: string | undefined, wallets: string | undefined, loyaltyLandingDisabled: string | undefined, loyaltyLevelNotfDisabled: string | undefined, verifyEmailClosed: string | undefined, rtpLiveOnboardingClosed: string | undefined, preferredInGameCurrency: string | undefined, inGameCurrencyOnboardingClosed: string | undefined, hasVisitedBCIO: string | undefined } | undefined } | undefined, countryInfo: { __typename: 'UserManagementCountryInfo', id: string, countryCode: string | undefined, blocked: boolean | undefined } | undefined };

export const ErrorsFragmentDoc = gql`
    fragment ErrorsFragment on UserManagementError {
  message
  params {
    name
    value
  }
}
    `;
export const UserManagementFragmentDoc = gql`
    fragment UserManagementFragment on UserManagement {
  id
  user: currentUser {
    ...UserFragment
  }
  profile: currentProfile {
    ...ProfileFragment
  }
  countryInfo: currentCountryInfo(site: $site) {
    ...CountryInfoFragment
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${CountryInfoFragmentDoc}`;
export const UpdateUserSettingsMutationDocument = gql`
    mutation UpdateUserSettingsMutation($value: String!, $name: UserSettingName!, $site: String) {
  userManagementUpdateUserSettings(input: { name: $name, value: $value }) {
    userManagement {
      ...UserManagementFragment
    }
    errors {
      ...ErrorsFragment
    }
  }
}
    ${UserManagementFragmentDoc}
${ErrorsFragmentDoc}`;